import { lazy } from 'react';

const list = lazy(() => import('pages/sellingChannels/List'));

export { list };
